var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey"},[_c('div',{staticClass:"row"},[_c('member-list',{staticClass:"pt-3",attrs:{"facets":_vm.boardFacets,"query":_vm.boardQuery,"fields":_vm.boardFields,"title":this.$t('labels.board')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }